<template>
  <b-overlay :show="isLoading">
    <div class="row m-0">
      <b-table striped hover v-if="jiras.length > 0" :items="jiras" :fields="fields">
        <template v-slot:[`cell(${fields[0]})`]="row">          
          <span :title="row.item.titulo" class="icon_type_problem bg-gradient-dark" @click="openJira(row.item.link)" style="cursor: pointer;">            
            <i :class="'fa fa-' + row.item.icon"/>            
          </span>
          <span class="text_type_problem">{{ row.item.titulo }}</span>
        </template>
        <template v-slot:cell(status)="row">
          <b-badge :variant="row.item.status_variant">{{ row.item.status }}</b-badge>          
        </template>
      </b-table>
      <EmptyData v-else :title="$t('monitoramento.jira.table.empty')"/>
    </div>
  </b-overlay>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import EmptyData from "@/components/EmptyData";

export default {
  name: "Jira",
  components: {
    EmptyData
  },
  computed: {
    ...mapGetters({
      vns: 'vns/current',
      latestsJira: 'vns/monitor/getLatestsJira',
      isLoading: 'vns/monitor/isLoading',
    }),    
    fields() {      
      return [
        this.$t('monitoramento.resumo.tabs.jira.tabela_titulo.tipo'),
        this.$t('monitoramento.resumo.tabs.jira.tabela_titulo.status'),
        this.$t('monitoramento.resumo.tabs.jira.tabela_titulo.data_atualizacao')
      ]      
    },
    jiras() {
      let jiras = [];

      if (!this.latestsJira) {
        return jiras;
      }

      this.latestsJira.forEach(jira => {
        let typeTitle = this.getTitleJira(jira)
        let typeIcon = this.getIconJira(jira)
        let updatedAt = moment(String(jira.updated_at)).format('DD/MM/YYYY HH:mm:ss')

        let jiraObject = {};
        jiraObject[this.$t('monitoramento.resumo.tabs.jira.tabela_titulo.tipo')] = jira.type_problem;
        jiraObject[this.$t('monitoramento.resumo.tabs.jira.tabela_titulo.status')] = this.getStatusJira(jira);
        jiraObject['link'] = jira.jira_link;
        jiraObject[this.$t('monitoramento.resumo.tabs.jira.tabela_titulo.data_atualizacao')] = updatedAt;
        jiraObject['titulo'] = typeTitle;
        jiraObject['icon'] = typeIcon;
        jiraObject['status_variant'] = this.getStatusVariantJira(jira);

        jiras.push(jiraObject);
      });

      return jiras
    }
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
    'vns/monitor/listLatestsJira',
    ]),
    getIconJira(jira) {
      switch (jira.type_problem) {
        case 'LAST_IP':
          return 'network-wired'
          break;
        case 'TEMPERATURE':
          return 'thermometer-half fa-lg'
          break;        
      }

      return 'exclamation'
    },
    getTitleJira(jira) {
      switch (jira.type_problem) {
        case 'LAST_IP':
          return this.$t('monitoramento.jira.tipos_problema.ip')
          break;
        case 'TEMPERATURE':
          return this.$t('monitoramento.jira.tipos_problema.temperatura')
          break;        
      }

      return ''
    },
    getStatusJira(jira) {
      if (jira.status === 0) {
        return "Fechado";
      }
      return "Aberto"
    },
    getStatusVariantJira(jira) {
      if (jira.status === 0) {
        return "info";
      }
      return "warning"
    },
    openJira(link) {
      window.open(link, "_blank");
    }
  },
  async mounted() {
    await this['vns/monitor/listLatestsJira'](this.vns.id)
  }
}
</script>

<style lang="scss" scoped>
/deep/ .mx-datepicker-range {
  width: 100%;
}

.icon_type_problem {
  position: absolute;
  border-radius: 36px;
  border: 1px solid;
  width: 32px;
  height: 32px;
  text-align: center;
  padding-top: 5px;
  color: white;
  border-color: black;
}

.text_type_problem {
  margin-left: 40px;
}
</style>